import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';

// Styles
import 'bootstrap';
import 'vue-toastification/dist/index.css';
import 'vue-select/dist/vue-select.css';

// Plugins
import '@/plugins/veeValidate';
import '@/plugins/fontawesome';
import '@/plugins/vueTippy';
import '@/plugins/vueToastification';

import { useSessionHeartbeat } from '@/composables/sessionHeartbeat';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

// Session heartbeat — keeps the user session alive while the user is active,
// regardless of which backend serves the actual page data.
const heartbeat = useSessionHeartbeat();
window.addEventListener('customily:user-changed', ((e: CustomEvent) => {
    const user = e.detail;
    if (user && !user.UserImpersonatedFromId) {
        heartbeat.start();
    } else {
        heartbeat.stop();
    }
}) as EventListener);

const assistantRoot = document.getElementById('customily-assistant-root');
if (assistantRoot) {
    import(/* webpackChunkName: "chat_assistant" */ './assistant-main');
}
